// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

type FlightsGoogleOneTapClickContext = {|
  pageProperties: string,
  pageviewId: string,
|};

/** null value if context does not exist */
export default React.createContext<FlightsGoogleOneTapClickContext | null>(null);
